import { useEffect, useState } from 'react';

/**
 * Returns true if the given media query matches the current environment.
 *
 * ```tsx
 * const hasFinePointer = useMediaQuery('pointer: fine');
 * // -> true when a mouse is present
 * ```
 */
export const useMediaQuery = (
  mediaQuery: string,
  ssrValue: boolean = false,
): boolean => {
  if (mediaQuery.indexOf('(') === -1 && mediaQuery.indexOf(')') === -1) {
    mediaQuery = `(${mediaQuery})`;
  }

  const [match, setMatch] = useState<boolean>(ssrValue);

  useEffect(() => {
    const list = window.matchMedia(mediaQuery);

    setMatch(list.matches);

    const handleChange = ({ matches }: MediaQueryListEvent) => {
      setMatch(matches);
    };

    list.addEventListener('change', handleChange);

    return () => list.removeEventListener('change', handleChange);
  }, []);

  return match;
};
